// src/App.tsx
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import Layout from './components/layout/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Index';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';
import PayPalGebuehren from './pages/PayPalGebuehren';
import Haendlerkonditionen from './pages/Haendlerkonditionen';

// Initialize GA4
ReactGA.initialize('G-LXW04EJ7DH'); // Replace with your GA4 measurement ID

// Track page views
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <Router>
          <RouteTracker />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/paypal-gebuehren" element={<PayPalGebuehren />} />
              <Route path="/haendlerkonditionen" element={<Haendlerkonditionen />} />
            </Routes>
          </Layout>
        </Router>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;